import { ButtonProps } from '../../types/Generics/ButtonProps';

export const ButtonGreen = (props: ButtonProps) => (
  <button
    id={props.id}
    className="bg-mideo-green m-2 rounded-md px-4 py-2 text-2xl text-white hover:bg-green-800 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-500 disabled:shadow-none sm:px-8 sm:py-3"
    type={props.type || 'button'}
    onClick={props.onClick}
    disabled={props.disabled}
  >
    {props.textContent}
  </button>
);
